import { render } from "./BetaTesterPage.vue?vue&type=template&id=5e1a684f"
import script from "./BetaTesterPage.vue?vue&type=script&lang=js"
export * from "./BetaTesterPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__